<template>
  <div class="c-grid__item">
    <sc-text tag="h5" class="grid-title" v-if="fields && fields.name" :field="fields.name" />
    <sc-rich-text
      tag="div"
      class="grid-content"
      :class="[{ ctaVisible: fields?.cta?.value?.text?.length > 0 }]"
      v-if="fields && fields.content"
      :field="fields.content"
    />
    <sc-link
      v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
      :field="fields.cta"
      class="c-cta--secondary"
      :class="fields.cta.value.class"
    />
    <button
      aria-label="Expand"
      class="grid-expand"
      v-if="fields?.name?.value && fields?.hideModal?.value != true"
      @click="smallModal = true"
    />

    <!-- Modal -->
    <template v-if="isEditing">
      <div class="c-modal">
        <button
          class="c-modal__close"
          v-if="fields && fields.name && fields.name.value"
          @click="close(fields.name.value)"
        >
          X
        </button>
        <sc-text
          tag="h2"
          class="c-modal__title"
          v-if="fields && fields.name"
          :field="fields.name"
        />
        <sc-rich-text
          tag="div"
          class="c-modal__content"
          v-if="fields && fields.modalContent"
          :field="fields.modalContent"
        />
      </div>
    </template>
    <template v-else>
      <VueFinalModal
        v-model="smallModal"
        class="final-modal smallModal"
        :class="{ scroll: isScrollable }"
        content-class="final-modal-content"
        content-transition="vfm-fade"
        overlay-transition="vfm-fade"
      >
        <div ref="modalContent" class="c-modal">
          <div class="c-modal__content">
            <button class="c-modal__close" @click="smallModal = false">X</button>
            <sc-text
              tag="h2"
              class="c-modal__title"
              v-if="fields && fields.name"
              :field="fields.name"
            />
            <sc-rich-text
              tag="div"
              v-if="fields && fields.modalContent"
              :field="fields.modalContent"
            />
          </div>
        </div>
      </VueFinalModal>
    </template>
  </div>
</template>

<script>
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue';
import { ref, reactive } from 'vue';
import { useWindowSize, useElementSize } from '@vueuse/core';
import { VueFinalModal } from 'vue-final-modal';
import 'vue-final-modal/style.css';

export default {
  name: 'CIS-Grid-Item',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScLink: Link,
    VueFinalModal
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    // Window Height
    const { height } = useWindowSize();
    // Small Modal
    const smallModal = ref(false);
    // Modal Content
    const modalContent = ref(null);
    // Get Modal Content Size
    const modalSize = reactive(useElementSize(modalContent));

    return {
      height,
      smallModal,
      modalContent,
      modalSize
    };
  },
  computed: {
    isEditing() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the `sitecoreContext` provided in layout service data.
      return this.$jss.sitecoreContext().pageEditing;
    },
    isScrollable() {
      return this.modalSize?.height > this.height;
    }
  }
};
</script>
